export const INVALID_LABWARE_DEFINITION_URI = 'INVALID_LABWARE_DEFINITION_URI';
export const LABWARE_FINAL_LOCATION_SELF_COLLISION =
  'LABWARE_FINAL_LOCATION_SELF_COLLISION';
export const LABWARE_FINAL_LOCATION_SLOT_CAPACITY_EXCEEDED =
  'LABWARE_FINAL_LOCATION_SLOT_CAPACITY_EXCEEDED';
export const LABWARE_FINAL_LOCATION_SLOT_COLLISION =
  'LABWARE_FINAL_LOCATION_SLOT_COLLISION';
export const LABWARE_START_LOCATION_SELF_COLLISION =
  'LABWARE_START_LOCATION_SELF_COLLISION';
export const LABWARE_START_LOCATION_SLOT_CAPACITY_EXCEEDED =
  'LABWARE_START_LOCATION_SLOT_CAPACITY_EXCEEDED';
export const LABWARE_START_LOCATION_SLOT_COLLISION =
  'LABWARE_START_LOCATION_SLOT_COLLISION';
export const LABWARE_START_LOCATION_SLOT_INVALID =
  'LABWARE_START_LOCATION_SLOT_INVALID';
export const MISSING_LABWARE_DEFINITION_URI = 'MISSING_LABWARE_DEFINITION_URI';
export const MISSING_START_LOCATION = 'MISSING_START_LOCATION';
export const LABWARE_SLOT_COLLISION = 'LABWARE_SLOT_COLLISION';

export type LabwareError =
  | typeof INVALID_LABWARE_DEFINITION_URI
  | typeof LABWARE_FINAL_LOCATION_SELF_COLLISION
  | typeof LABWARE_FINAL_LOCATION_SLOT_CAPACITY_EXCEEDED
  | typeof LABWARE_FINAL_LOCATION_SLOT_COLLISION
  | typeof LABWARE_START_LOCATION_SELF_COLLISION
  | typeof LABWARE_START_LOCATION_SLOT_CAPACITY_EXCEEDED
  | typeof LABWARE_START_LOCATION_SLOT_COLLISION
  | typeof LABWARE_START_LOCATION_SLOT_INVALID
  | typeof MISSING_LABWARE_DEFINITION_URI
  | typeof MISSING_START_LOCATION
  | typeof LABWARE_SLOT_COLLISION;
